import axios from 'axios'
import oauthInstance from './oauth'
import { api as libraryServicesApi } from '@/lib/services'

const localhostServer = process.env.VUE_APP_ROOT_URL
const clientDomain = window.location.origin

const domain = localhostServer || clientDomain

export default oauthInstance(axios, domain, libraryServicesApi)
